import { RouteRecordRaw } from 'vue-router'

import ChangeExistingPassword from '@/popup/components/views/Home/Settings/ChangePassword/ChangeExistingPassword.vue'
import ConfirmChangePassword from '@/popup/components/views/Home/Settings/ChangePassword/ConfirmChangePassword.vue'

const changePasswordRoutes: Array<RouteRecordRaw> = [
  {
    path: '/settings/password/change/create-new-password',
    name: 'changeExistingPassword',
    component: ChangeExistingPassword,
  },
  {
    path: '/settings/password/change/confirm-password',
    name: 'confirmChangePassword',
    component: ConfirmChangePassword,
  },
]

export default changePasswordRoutes
